/**
 * Auth Feature Endpoints
 *
 * Centralized endpoint definitions for all authentication-related API calls.
 * These are relative paths - use with getApiUrl() from @/utils/api.
 */

const OAUTH_BASE = "/oauth";

export const AUTH_ENDPOINTS = {
  /** POST - Initial login with email/password/captcha, returns token or 2FA challenge */
  LOGIN_2FA: `${OAUTH_BASE}/2fa_token`,

  /** POST - Verify 2FA code after initial login */
  VERIFY_2FA: `${OAUTH_BASE}/verify_2fa_token`,

  /** POST - Register phone number for 2FA */
  REGISTER_PHONE: `${OAUTH_BASE}/register_phone`,

  /** POST - Refresh access token */
  REFRESH_TOKEN: `${OAUTH_BASE}/refresh_token`,

  /** POST - Revoke token (logout) */
  LOGOUT: `${OAUTH_BASE}/logout`,

  /** POST - Request password reset email */
  RESET_PASSWORD: `${OAUTH_BASE}/reset_password`,

  /** POST - Set new password using reset token */
  SET_PASSWORD: `${OAUTH_BASE}/set_password`,

  /** POST - Resend reset link when token is expired */
  RESEND_RESET_LINK: `${OAUTH_BASE}/resend_reset_link`,

  /** POST - Admin impersonation */
  IMPERSONATE: `${OAUTH_BASE}/impersonate`,

  /** POST - Exchange grant login token for access token */
  EXCHANGE_GRANT_LOGIN: `${OAUTH_BASE}/exchange_grant_login`,

  /** POST - Generate cross-scope login token (authenticated) */
  GENERATE_CROSS_SCOPE_TOKEN: `${OAUTH_BASE}/generate_cross_scope_token`,

  /** POST - Exchange cross-scope login token for access token */
  EXCHANGE_CROSS_SCOPE_TOKEN: `${OAUTH_BASE}/exchange_cross_scope_token`,

  /** GET - Fetch current authenticated user */
  GET_CURRENT_USER: "/representatives/me",

  /** GET - Fetch organization plan (requires organization ID) */
  GET_ORGANIZATION_PLAN: (organizationId: string) => `/organizations/${organizationId}/plan`,

  /** GET - Public configuration (captcha, version info) */
  CONFIG: "/config",
} as const;

export type AuthEndpoint = (typeof AUTH_ENDPOINTS)[keyof typeof AUTH_ENDPOINTS];
